import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'COURSE_UPDATE',
    smsDelete : 'COURSE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        category: [],
        category_parent: [],
        category_list_by_parent: [],
        categoryLoading: false,
        categoryError: false,
        sub_categoryLoading: false,
        sub_categoryError: false,

        course: [],
        course_detail: {},
        e_book: [],
        submitSuccess: false,
        courseLoading: false,
        courseError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_PARENT_CATEGORY(state, category) {
            state.category_parent = category;
        },

        SET_CATEGORY(state, category) {
            state.category = category;
        },

        SET_CATEGORY_SUB(state, category) {
            state.category_list_by_parent = category;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, hasError) {
            state.categoryError = hasError;
        },
        
        SUB_CATEGORY_LOADING (state, loading) {
            state.sub_categoryLoading = loading;
        },

        SUB_CATEGORY_ERROR (state, hasError) {
            state.sub_categoryError = hasError;
        },

        SET_COURSE(state, course) {
            state.course = course;
        },

        SET_COURSE_DETAIL(state, course) {
            state.course_detail = course;
        },

        SET_EBOOK(state, e_book) {
            state.e_book = e_book;
        },

        COURSE_LOADING (state, loading) {
            state.courseLoading = loading;
        },

        COURSE_ERROR (state, hasError) {
            state.courseError = hasError;
        }
    },

    actions: {
        // CATEGORY
        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_course_category, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchCategoryParent ({commit, dispatch}) {
            commit('PARENT_CATEGORY_LOADING', true);
            commit('PARENT_CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.course_category_parent, config);
                let response = result.data
                commit('SET_PARENT_CATEGORY', response.data);

            } catch(error) {
                commit('PARENT_CATEGORY_ERROR', true);
            } finally {
                commit('PARENT_CATEGORY_LOADING', false);
            }
        },

        async fetchCategory ({commit, dispatch}) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.course_category_list, config);
                let response = result.data
                commit('SET_CATEGORY', response.data);

            } catch(error) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchSubCategory ({commit, dispatch}, payload) {
            commit('SUB_CATEGORY_LOADING', true);
            commit('SUB_CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.course_category_list_by_parent + payload, config);
                let response = result.data
                commit('SET_CATEGORY_SUB', response.data);

            } catch(error) {
                commit('SUB_CATEGORY_ERROR', true);
            } finally {
                commit('SUB_CATEGORY_LOADING', false);
            }
        },

        async updateCategory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_course_category + payload.id, payload.category, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },
        
        async deleteCategory({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.course_category_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCategory')
            return response
        },

        // COURSE
        async addCourse ({commit, dispatch}, payload) {
            commit('COURSE_LOADING', true);
            commit('COURSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_course, payload.course, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCourse')
                return response

            } catch (e) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },

        async fetchCourse ({ commit }) {
            commit('COURSE_LOADING', true);
            commit('COURSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.course_list, config);
                let response = result.data
                commit('SET_COURSE', response.results);

            } catch(error) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },

        async fetchCourseDetail ({ commit }, payload) {
            commit('COURSE_LOADING', true);
            commit('COURSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.course_detail + payload, config);
                let response = result.data.data
                commit('SET_COURSE_DETAIL', response);

            } catch(error) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },

        async updateCourse ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_course + payload.slug, payload.course, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCourse')
                return response

            } catch (e) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },
        
        async deleteCourse({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.course_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCourse')
            return response
        },

        // E-BOOK
        async addEBook ({commit, dispatch}, payload) {
            commit('COURSE_LOADING', true);
            commit('COURSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_e_book, payload.e_book, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchEBook')
                return response

            } catch (e) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },

        async fetchEBook ({ commit }) {
            commit('COURSE_LOADING', true);
            commit('COURSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.e_book_list, config);
                let response = result.data
                commit('SET_EBOOK', response.data);

            } catch(error) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },

        async updateEBook ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_e_book + payload.id, payload.e_book, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchEBook')
                return response

            } catch (e) {
                commit('COURSE_ERROR', true);
            } finally {
                commit('COURSE_LOADING', false);
            }
        },
        
        async deleteEBook ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.e_book_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchEBook')
            return response
        }
    },

    getters: {}
}
